// Ready-made roofing scope-of-work templates new users can copy and edit.
const B = "https://static.prod-images.emergentagent.com/jobs/b4624a9d-c450-44a4-a99e-4a1678bc709b/images/";
const IMG = {
  deck: B + "b6d3a28a2759581110d7d928b42844fd8748bf0c8c0e2ab17216b4b2de04c419.jpeg",
  underlayment: B + "1a8945f4dbc44e2f41d2b3d12c4a968fbf5eb1281719003ff2a97b4fff68b064.jpeg",
  shingles: B + "825a625945cae5694fee8fad1a37fcafe49c1f4cc81794b59927da08c08f7735.jpeg",
  flashing: B + "454058de7c51c3c5ac9edc2f5c5e275905d2b189e30ed6cadfb68c6f824a4b37.jpeg",
  vent: B + "57e610f9e8313503e3e0cde94b4377d53e0932cbbf834cadc6a5edfd1118f926.jpeg",
  permit: B + "ab9e011e73bd246596057abf3595449a8eece0473dd36c8f45faa4b9e52916cc.jpeg",
  protect: B + "a79acfb619c65899cecfb24d09247f1a108813706b2a2476bb54d899471e15a7.jpeg",
  tearoff: B + "b76a245b809fe662d9251b5dbc1986ee3bb411ca9cf153a2178466ab6a257ebf.jpeg",
  debris: B + "c8a92f3a8fe5da5f8ad2fbaf0f12c032cb075c6a48bf5c60be345f5860aa79b1.jpeg",
  dripedge: B + "fbea6207938f40ef445e70744f5fcfcce477721f54ceacafe429c43ca3476005.jpeg",
  icewater: B + "2b0375597897387793e86889802e8dd095f0f7d09521f1133b0d5327859bd78f.jpeg",
  starter: B + "0c37d09fae055d2456400ed43762eef85c63204346f1b58b260d7ebe979dd9f9.jpeg",
  pipeboot: B + "3b620ad7d2205a0730c5dce307f6c83e47137d68534277e59ff635d7b0077eb4.jpeg",
  ridgecap: B + "338bac69443764ab86d4607db5c176608c07927df8a9b6c831dcbd0248d0aba2.jpeg",
  cleanup: B + "d5b03473125055db79d0179dbcd3caade45fddd946a0572e327d1530765adcb0.jpeg",
};
const s = (title, description, image_url = "") => ({ title, description, image_url });

export const STARTER_SCOPES = [
  {
    name: "Shingle Tear-Off & Replace",
    description: "Full 17-step architectural shingle roof replacement.",
    items: [
      s("Pull Permit", "Obtain the required city/county roofing permit before work begins.", IMG.permit),
      s("Protect Property", "Tarp and shield landscaping, plants, AC units, and siding around the home.", IMG.protect),
      s("Full Tear-Off", "Remove all existing roofing layers down to the wood decking.", IMG.tearoff),
      s("Haul Away & Dispose", "Load, haul away, and properly dispose of all old roofing debris.", IMG.debris),
      s("Inspect & Re-Nail Decking", "Inspect the deck and re-nail all sheathing to current code.", IMG.deck),
      s("Replace Damaged Decking", "Replace any rotten or damaged decking (billed per sheet if needed).", IMG.deck),
      s("Install Drip Edge", "Install new metal drip edge at all eaves and rakes.", IMG.dripedge),
      s("Ice & Water Shield", "Self-adhered ice & water membrane in valleys, penetrations, and eaves.", IMG.icewater),
      s("Synthetic Underlayment", "Full synthetic moisture-barrier underlayment across the entire roof.", IMG.underlayment),
      s("Starter Shingles", "Factory starter strip along all eaves and rakes for wind resistance.", IMG.starter),
      s("Install Architectural Shingles", "Manufacturer-certified architectural shingles, 6 nails per shingle.", IMG.shingles),
      s("Step & Counter Flashing", "New step and counter flashing at all walls and chimneys.", IMG.flashing),
      s("Valley Flashing", "New metal or woven valley flashing for watertight valleys.", IMG.flashing),
      s("Pipe Boots & Penetrations", "New rubber pipe boots and sealed flashing at every roof penetration.", IMG.pipeboot),
      s("Attic Ventilation", "Balanced ridge and intake ventilation for a healthy attic.", IMG.vent),
      s("Ridge Cap Shingles", "Premium high-profile ridge cap shingles along all ridges.", IMG.ridgecap),
      s("Magnetic Nail Sweep & Cleanup", "Full magnetic nail sweep and complete jobsite cleanup.", IMG.cleanup),
    ],
  },
  {
    name: "Roof Repair",
    description: "Targeted leak / storm-damage repair scope.",
    items: [
      s("Inspect & Document Damage", "Full inspection with photos of the damaged area for the customer file.", IMG.protect),
      s("Protect Work Area", "Tarp and protect the surrounding roof, gutters, and landscaping.", IMG.protect),
      s("Remove Damaged Section", "Carefully remove the affected shingles and underlayment.", IMG.tearoff),
      s("Repair / Replace Decking", "Replace any rotted or damaged decking under the affected area.", IMG.deck),
      s("New Underlayment & Flashing", "Install fresh underlayment, ice & water shield, and flashing as needed.", IMG.icewater),
      s("Install Matching Shingles", "Weave in matching architectural shingles for a seamless repair.", IMG.shingles),
      s("Seal, Test & Cleanup", "Seal all penetrations, water-test the repair, and magnetic-sweep the area.", IMG.cleanup),
    ],
  },
  {
    name: "Metal / Standing-Seam",
    description: "Standing-seam metal roof replacement scope.",
    items: [
      s("Pull Permit", "Obtain the required city/county roofing permit before work begins.", IMG.permit),
      s("Protect Property", "Tarp and shield landscaping, AC units, and siding around the home.", IMG.protect),
      s("Full Tear-Off & Haul Away", "Remove all existing roofing down to the deck and dispose of debris.", IMG.tearoff),
      s("Inspect & Re-Nail Decking", "Inspect the deck and re-nail all sheathing to current code.", IMG.deck),
      s("High-Temp Underlayment", "Install high-temperature self-adhered underlayment across the roof.", IMG.underlayment),
      s("Drip Edge & Eave Trim", "Install metal drip edge, eave, and rake trim.", IMG.dripedge),
      s("Install Standing-Seam Panels", "Mechanically-seamed or snap-lock metal panels with concealed fasteners.", IMG.shingles),
      s("Flashing & Penetrations", "Custom metal flashing at walls, chimneys, valleys, and penetrations.", IMG.flashing),
      s("Ridge Caps & Closures", "Install ridge caps, closures, and ventilation.", IMG.ridgecap),
      s("Magnetic Sweep & Cleanup", "Full magnetic nail sweep and complete jobsite cleanup.", IMG.cleanup),
    ],
  },
  {
    name: "Flat / TPO",
    description: "Low-slope TPO membrane roof replacement scope.",
    items: [
      s("Pull Permit", "Obtain the required city/county roofing permit before work begins.", IMG.permit),
      s("Protect Property", "Protect walls, drains, and surroundings before work begins.", IMG.protect),
      s("Remove Existing Membrane", "Tear off the old membrane and insulation down to the deck.", IMG.tearoff),
      s("Inspect & Repair Decking", "Inspect and repair/replace any damaged roof decking.", IMG.deck),
      s("Install ISO Insulation Board", "Mechanically fasten polyiso insulation board for R-value and slope.", IMG.underlayment),
      s("Heat-Welded TPO Membrane", "Install and hot-air-weld the TPO membrane with sealed seams.", IMG.shingles),
      s("Flashing & Edge Metal", "Install membrane flashing, drains, and edge metal termination.", IMG.flashing),
      s("Water Test & Cleanup", "Flood/water-test seams and drains, then complete jobsite cleanup.", IMG.cleanup),
    ],
  },
];
